import { promptManagementApi } from 'common/api'

export type BrazeCampaign = {
  id: string
  name: string
  last_edited: string
}

export type CampaignMessage = {
  channel: string
  subject?: string
  body?: string
}

export type BrazeCampaignDetail = {
  integration: string
  campaign_id: string
  campaign_name: string
  description: string
  tags: string[]
  channels: string[]
  messages: CampaignMessage[]
}

type GetCampaignsResponse = {
  integration: string
  project_id: string
  campaigns: BrazeCampaign[]
}

export const getCampaigns = async ({
  accountId,
  projectId,
  integration,
}: {
  accountId: string
  projectId: string
  integration: string
}): Promise<BrazeCampaign[]> => {
  const result = await promptManagementApi.get<GetCampaignsResponse>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/campaigns`
  )

  return result.data.campaigns
}

export type BrazeCanvasStep = {
  name: string
  type: string
  messages: CampaignMessage[]
}

export type BrazeCanvasDetail = {
  integration: string
  canvas_id: string
  canvas_name: string
  description: string
  tags: string[]
  channels: string[]
  steps: BrazeCanvasStep[]
}

type GetCanvasesResponse = {
  integration: string
  project_id: string
  canvases: BrazeCampaign[]
}

export const getCanvases = async ({
  accountId,
  projectId,
  integration,
}: {
  accountId: string
  projectId: string
  integration: string
}): Promise<BrazeCampaign[]> => {
  const result = await promptManagementApi.get<GetCanvasesResponse>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/canvases`
  )

  return result.data.canvases
}

export const getCanvasDetail = async ({
  accountId,
  projectId,
  integration,
  canvasId,
}: {
  accountId: string
  projectId: string
  integration: string
  canvasId: string
}): Promise<BrazeCanvasDetail> => {
  const result = await promptManagementApi.get<BrazeCanvasDetail>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/canvases/${canvasId}`
  )

  return result.data
}

export const getCampaignDetail = async ({
  accountId,
  projectId,
  integration,
  brazeCampaignId,
}: {
  accountId: string
  projectId: string
  integration: string
  brazeCampaignId: string
}): Promise<BrazeCampaignDetail> => {
  const result = await promptManagementApi.get<BrazeCampaignDetail>(
    `accounts/${accountId}/projects/${projectId}/integrations/${integration}/campaigns/${brazeCampaignId}`
  )

  return result.data
}
